import React from 'react'
import image1 from '../assets/servicesNavbar/1.png'
import image2 from '../assets/servicesNavbar/2.png'
import image3 from '../assets/servicesNavbar/3.png'
import image4 from '../assets/servicesNavbar/4.png'
import icon1 from '../assets/homeServicesSection/icon3.png'
import icon2 from '../assets/homeServicesSection/icon1.png'
import icon3 from '../assets/homeServicesSection/icon2.png'
import arrow from '../assets/viewdetails.png'
import { Link } from 'react-router-dom'

const services = [
  {
    icon: icon1,
    image: image1,
    title: "AI/ ML Development",
    desc: 'AI/ML (Artificial Intelligence/Machine Learning) uses algorithms to enable machines to learn from data and perform tasks that traditionally require.',
    link: ''
  },
  {
    icon: icon2,
    image: image2,
    title: "Avinya NGO app",
    desc: 'ERP software centralizes and automates business processes, enhancing efficiency and decision-making with real-time visibility across departments.',
    link: ''
  },
  {
    icon: icon2,
    image: image3,
    title: "Erp Software",
    desc: 'ERP software centralizes and automates business processes, enhancing efficiency and decision-making with real-time visibility across departments.',
    link: ''
  },
  {
    icon: icon3,
    image: image4,
    title: "Web Development",
    desc: 'Web development is the process of bringing websites and web applications to life. It involves everything from the initial design, planning, coding & Programming ',
    link: ''
  }
]

const ServicesNavbar = () => {
  return (
    <>
      {/* ===== Desktop View ===== */}
      <div className='w-full bg-white p-[40px] px-[18px] shadow-[0px_4px_4px_0px_#00000040] gap-[40px] absolute top-19  left-0 z-10 hidden lg:flex'>

        {/* Card Section */}
        <div className='h-[333.3px] pt-[2px] gap-[20px] relative flex'>
          {services.map((s, index) => (
            <div key={index} className='w-[209px] h-[350px] shadow-[0px_4px_10px_0px_rgba(0,0,0,0.2)] bg-white rounded overflow-hidden flex flex-col transform transition duration-300 hover:scale-[1.03] hover:shadow-lg'>
              <img src={s.image} className='object-cover h-[160px] w-full rounded-t' alt='service' />
              <div className='relative flex flex-col flex-grow px-4 pt-10 pb-4'>
                <div className='w-[49px] h-[49px] p-[10px] rounded-full shadow bg-white absolute -top-[24px] left-1/2 transform -translate-x-1/2'>
                  <img src={s.icon} alt='icon' />
                </div>
                <div className='text-center flex flex-col items-center gap-2 flex-grow'>
                <p className='text-[12px] font-bold text-black'>{s.title}</p>
                  <p className='text-[11px] text-[#4A4A4A] italic leading-[15px] text-justify min-h-[75px]'>
                    {s.desc}
                  </p>
                </div>
                <div className='pt-2'>
                  <Link
                    to={s.link}
                    className='flex items-center justify-center gap-1 text-[12px] text-black hover:text-[#0058AE] transition duration-300'
                  >
                    View Details
                    <img src={arrow} alt='arrow' className='w-[9px]' />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Left Service Links */}
        <div className='border-l-2 pl-6 pr-4 py-4 flex flex-col justify-center'>
          <ul className='space-y-3 text-[14px] font-medium text-gray-800'>
            <li className='flex items-center gap-2 hover:text-[#0058AE]'><span className='text-[#0058AE] text-[16px]'>✔</span><Link to='/webdev'>Website Development</Link></li>
            <li className='flex items-center gap-2 hover:text-[#0058AE]'><span className='text-[#0058AE] text-[16px]'>✔</span><Link to='/appdev'>Application Development</Link></li>
            <li className='flex items-center gap-2 hover:text-[#0058AE]'><span className='text-[#0058AE] text-[16px]'>✔</span><Link to='/allindustrymanufacturingerps'>Manufacturing ERP (All Industry)</Link></li>
            <li className='flex items-center gap-2 hover:text-[#0058AE]'><span className='text-[#0058AE] text-[16px]'>✔</span><Link to='/hrms'>Esparse HRMS Solution</Link></li>
            <li className='flex items-center gap-2 hover:text-[#0058AE]'><span className='text-[#0058AE] text-[16px]'>✔</span><Link to='/crm'>Esparse CRM Solution</Link></li>
            <li className='flex items-center gap-2 hover:text-[#0058AE]'><span className='text-[#0058AE] text-[16px]'>✔</span><Link to='/erp'>ERP for School & College</Link></li>
            <li className='flex items-center gap-2 hover:text-[#0058AE]'><span className='text-[#0058AE] text-[16px]'>✔</span><Link to='/csds'>Custom Software Development</Link></li>
          </ul>
        </div>

        {/* Right Service Links */}
        <div className='border-l-2 pl-6 pr-4 py-4 flex flex-col justify-center'>
          <ul className='space-y-3 text-[14px] font-medium text-gray-800'>
            <li className='flex items-center gap-2 hover:text-[#0058AE]'><span className='text-[#0058AE] text-[16px]'>✔</span><Link to='/ai'>AI Software Development</Link></li>
            <li className='flex items-center gap-2 hover:text-[#0058AE]'><span className='text-[#0058AE] text-[16px]'>✔</span><Link to='/ds'>Data Science Consulting</Link></li>
            <li className='flex items-center gap-2 hover:text-[#0058AE]'><span className='text-[#0058AE] text-[16px]'>✔</span><Link to='/devops'>DevOps Products</Link></li>
            <li className='flex items-center gap-2 hover:text-[#0058AE]'><span className='text-[#0058AE] text-[16px]'>✔</span><Link to='/ml'>ML Products</Link></li>
            <li className='flex items-center gap-2 hover:text-[#0058AE]'><span className='text-[#0058AE] text-[16px]'>✔</span><Link to='/st'>Software Testing</Link></li>
            <li className='flex items-center gap-2 hover:text-[#0058AE]'><span className='text-[#0058AE] text-[16px]'>✔</span><Link to='/uiux'>UI/UX Design</Link></li>
          </ul>
        </div>
      </div>

     {/* ===== Mobile View (Fixed, aligned) ===== */}
<div className='w-full bg-white px-6 py-4 flex flex-col gap-6 lg:hidden justify-center items-center'>
  <div className='grid grid-cols-2 gap-x-6 gap-y-3 text-[15px] text-gray-900'>
    {/* Combined full list with links, aligned row-wise */}
    <Link to='/' className='hover:text-[#0058AE]'>1. AI/ ML Development</Link>
    <Link to='/' className='hover:text-[#0058AE]'>2. Avinya NGO app</Link>
    <Link to='/' className='hover:text-[#0058AE]'>3. Erp Software</Link>
    <Link to='/' className='hover:text-[#0058AE]'>4. Web Development</Link>
    <Link to='/webdev' className='hover:text-[#0058AE]'>5. Website Development</Link>
    <Link to='/appdev' className='hover:text-[#0058AE]'>6. Application Development</Link>
    <Link to='/allindustrymanufacturingerps' className='hover:text-[#0058AE]'>7. Manufacturing ERP (All Industry)</Link>
    <Link to='/hrms' className='hover:text-[#0058AE]'>8. Esparse HRMS Solution</Link>
    <Link to='/crm' className='hover:text-[#0058AE]'>9. Esparse CRM Solution</Link>
    <Link to='/erp' className='hover:text-[#0058AE]'>10. ERP for School & College</Link>
    <Link to='/csds' className='hover:text-[#0058AE]'>11. Custom Software Development</Link>
    <Link to='/ai' className='hover:text-[#0058AE]'>12. AI Software Development</Link>
    <Link to='/ds' className='hover:text-[#0058AE]'>13. Data Science Consulting</Link>
    <Link to='/devops' className='hover:text-[#0058AE]'>14. DevOps Products</Link>
    <Link to='/ml' className='hover:text-[#0058AE]'>15. ML Products</Link>
    <Link to='/st' className='hover:text-[#0058AE]'>16. Software Testing</Link>
    <Link to='/uiux' className='hover:text-[#0058AE]'>17. UI/UX Design</Link>
  </div>
</div>


    </>
  )
}

export default ServicesNavbar
